<template>
  <tr>
    <td class="td-title">
      <div class="push_text">
        {{ item.title }}
      </div>
    </td>
    <td class="td-body">
      <div class="push_text">{{ item.body }}</div>
    </td>
    <td class="td-date">
      {{ $formatDate(item.created_at) }}
    </td>
    <td class="td-author">{{ item.author.first_name + ' ' + item.author.last_name }}</td>
    <td class="td-status">
      <div class="d-flex" style="gap: 5px">
        <BaseTooltip
          :tooltip="
            localStorage.translations.pages['setting-push_notifications'].statuses[
              item.schedule_status
            ]
          "
        >
          <BaseIcon :icon="'push-status-' + item.schedule_status" />
        </BaseTooltip>
        <BaseTooltip
          :tooltip="
            localStorage.translations.pages['setting-push_notifications'].main['successful_count']
          "
        >
          {{ item.successful_count }}
        </BaseTooltip>
      </div>
    </td>
    <td class="td-recipients">
      <SettingsPushNotificationsRecipientsModal
        :recipients="
          target === 'projects'
            ? item.work_client_projects
            : item.recipients_group === 'all'
            ? []
            : item.recipients
        "
        :projectsStatus="item.projects_group"
      />
    </td>
    <td v-if="target === 'triggered' || target === 'projects'" class="td-trigger">
      {{ triggersList(item.trigger) }}
    </td>
    <td class="td-type">{{ pushTypeList(item.schedule.type) }}</td>
    <td class="td-date" style="white-space: pre-line">
      {{
        item.trigger !== 'client_bill_sent'
          ? item.schedule.type === 'immediate'
            ? target === 'manual'
              ? '-'
              : $formatDate(item.created_at)
            : item.schedule.type === 'delayed'
            ? $formatDate(
                new Date(
                  new Date(item.created_at).getTime() + item.schedule.delay * 60000,
                ).toISOString(),
              )
            : item.schedule.type === 'once'
            ? $formatDate(item.schedule.send_at)
            : item.schedule.type === 'repeating'
            ? $formatDate(item.schedule.start_at) +
              '\n' +
              (item.until
                ? $formatDate(item.until)
                : item.schedule.repeats > 0
                ? calculationUntil({
                    start_at: item.schedule.start_at,
                    delay: item.schedule.delay,
                    interval: item.schedule.interval,
                    repeats: item.schedule.repeats,
                  })
                : '-')
            : $formatDate(item.created_at)
          : '-'
      }}
    </td>
    <td class="td-buttons">
      <div class="buttons">
        <template
          v-if="
            $userCheckAccess({ checkUserType: 'superadmin' }) ||
            $userCheckAccess({ abilities: 'edit_notifications' })
          "
        >
          <DeleteModal
            v-if="item.schedule_status === 'created'"
            :text="
              localStorage.translations.pages['setting-push_notifications'].dialogs['delete'] +
              ' ' +
              item.title
            "
            :methodDelete="onDeleteNotificationAdminManual"
          />
          <SettingsPushNotificationsModal
            v-if="
              target === 'manual'
                ? item.schedule_status !== 'done' && item.schedule.type !== 'immediate'
                : true
            "
            modal-type="edit"
            :onDownloadPageData="onDownloadPageData"
            :itemData="item"
            :id="item.id"
            :type="target"
          />
        </template>
        <SettingsPushNotificationsModal
          modal-type="show"
          :onDownloadPageData="onDownloadPageData"
          :itemData="item"
          :id="item.id"
          :type="target"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import DeleteModal from 'components/DeleteModal'
import SettingsPushNotificationsModal from 'components/setting/pushNotifications/SettingsPushNotificationsModal'
import SettingsPushNotificationsRecipientsModal from 'components/setting/pushNotifications/SettingsPushNotificationsRecipientsModal'
import { mapActions } from 'vuex'
export default {
  name: 'SettingsPushNotificationsTableItem',
  components: {
    DeleteModal,
    SettingsPushNotificationsModal,
    SettingsPushNotificationsRecipientsModal,
  },
  props: {
    item: Object,
    onDownloadPageData: Function,
    target: String,
  },
  data: () => ({
    is_active: false,
    is_active_loading: false,
  }),
  created() {
    this.is_active = this.item.is_active
  },
  mounted() {
    this.is_active = this.item.is_active
  },
  watch: {
    is_active() {
      this.item.is_active = this.is_active
    },
  },
  methods: {
    ...mapActions('notificationAdminManual', [
      'onNotificationAdminManualUpdate',
      'onNotificationAdminManualDelete',
    ]),
    ...mapActions('notificationAdminTriggered', [
      'onNotificationAdminTriggeredUpdate',
      'onNotificationAdminTriggeredDelete',
    ]),
    ...mapActions('notificationAdminProject', [
      'onNotificationAdminProjectUpdate',
      'onNotificationAdminProjectDelete',
    ]),
    calculationUntil({ start_at, delay, interval, repeats }) {
      let result = this.$formatDate(
        new Date(
          new Date(this.target === 'manual' ? start_at : '2022-02-22 ' + start_at).getTime() +
            (delay ? delay * 60000 : 0) +
            interval * repeats * 60000,
        ).toISOString(),
      )
      if (this.target !== 'manual') {
        let [date, time] = result.split(' ')
        result = date == '22.02.2022' ? time : '23:59'
      }
      return result
    },
    pushTypeList(type) {
      let result = this.localStorage.translations.pages['setting-push_notifications'].types[type]
      return result || type
    },
    triggersList(trigger) {
      let result =
        this.localStorage.translations.pages['setting-push_notifications'].triggers[trigger]
      return result || trigger
    },
    onDeleteNotificationAdminManual() {
      this[
        this.target === 'manual'
          ? 'onNotificationAdminManualDelete'
          : this.target === 'projects'
          ? 'onNotificationAdminProjectDelete'
          : 'onNotificationAdminTriggeredDelete'
      ]({ id: this.item.id })
        .then((response) => {
          console.log(response)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
              IsError: false,
            },

            { root: true },
          )
          this.onDownloadPageData()
        })
        .catch((err) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            { root: true },
          )
        })
    },
    onChangeIsActive(v) {
      this.is_active_loading = true
      this[
        this.target === 'manual'
          ? 'onNotificationAdminManualUpdate'
          : this.target === 'projects'
          ? 'onNotificationAdminProjectUpdate'
          : 'onNotificationAdminTriggeredUpdate'
      ]({
        id: this.item.id,
        data: {
          is_active: this.is_active,
        },
      })
        .then(() => (this.is_active_loading = false))
        .catch(() => {
          this.is_active_loading = false
          this.is_active = !this.is_active
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            { root: true },
          )
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.push {
  &_text {
    white-space: pre-line;
    margin: 0; /* Убираем внешний отступ */
    -webkit-line-clamp: 1; /* Число отображаемых строк */
    display: -webkit-box; /* Включаем флексбоксы */
    -webkit-box-orient: vertical; /* Вертикальная ориентация */
    overflow: hidden; /* Обрезаем всё за пределами блока */
  }
}
.td-active:deep() {
  .v-input--selection-controls {
    margin-top: 0 !important;
    padding-top: 0 !important;
    .v-input__slot {
      margin-bottom: 0 !important;
    }
    .v-messages {
      display: none;
    }
  }
}
</style>